import React from 'react'
import HelpfulBadge from 'assets/pro-plan/helpful.webp'
import SecurePaymentBadge from 'assets/pro-plan/secured_payment.webp'
import VerifiedContentBadge from 'assets/pro-plan/verified_content.webp'
import AppReviewIcon from 'assets/pro-plan/app_rating.svg'
import styled, { css } from 'styled-components'
import theme from 'stories/utils/theme'
import { localizeNumber, parseLocale } from 'lib/constants/localization'
import { KnowunityNumbers } from 'lib/constants/KnowunityNumbers'
import { useRouter } from 'next/router'

const Container = styled.div<{ backgroundColor?: string; background?: string }>`
    background-color: ${({ backgroundColor }) => backgroundColor ?? theme.colors.darkerAccentBlue};
    ${({ background }) =>
        background
            ? css`
                background: ${background}
                background-blend-mode: lighten;
                opacity: 0.8;
            `
            : 'none'};
    padding: 15px;
`

const Grid = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    grid-gap: 50px;
    padding: 15px 0;
    min-height: 90px;
    @media (max-width: 750px) {
        flex-wrap: wrap;
        justify-content: center;
    }
`

const ReviewWrapper = styled.span<{ isSmall?: boolean }>`
    height: ${({ isSmall }) => (isSmall ? 65 : 100)}px;

    h5 {
        position: relative;
        bottom: ${({ isSmall }) => (isSmall ? 60 : 75)}px;
        left: ${({ isSmall }) => (isSmall ? 70 : 130)}px;
        color: white;
    }
    p {
        position: relative;
        bottom: ${({ isSmall }) => (isSmall ? 60 : 75)}px;
        left: ${({ isSmall }) => (isSmall ? 60 : 130)}px;
        color: white;
        font-weight: 500;
        font-size: ${({ isSmall }) => (isSmall ? 12 : 14)}px;
    }
`

interface Props {
    backgroundColor?: string
    background?: string
}

const ProReferences = ({ backgroundColor, background }: Props) => {
    return (
        <Container backgroundColor={backgroundColor} background={background}>
            <Grid>
                <img src={SecurePaymentBadge.src} width={SecurePaymentBadge.width} height={SecurePaymentBadge.height} />
                <img
                    src={VerifiedContentBadge.src}
                    width={VerifiedContentBadge.width}
                    height={VerifiedContentBadge.height}
                />
                <img src={HelpfulBadge.src} width={HelpfulBadge.width} height={HelpfulBadge.height} />

                <AppReviewIcon />
            </Grid>
        </Container>
    )
}

export default ProReferences
